{
  "id": "campaign-141",
  "name": "Sunny Vale",
  "seed": "campaign:141",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..................",
    ".#.....h..........",
    "...#.m............",
    ".....mh...........",
    ".....m.....Y......",
    "...T..............",
    ".......*..........",
    ".x...x**..........",
    ".......*..#.......",
    "...........T......",
    "....#..x......h...",
    "......x..........T",
    "..................",
    "..h.....T.x.......",
    "....#.#...........",
    ".........m......T.",
    "........m.m..T....",
    "S........m........"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 10,
      "y": 11
    },
    {
      "kind": "fox",
      "x": 4,
      "y": 0
    },
    {
      "kind": "deer",
      "x": 14,
      "y": 13
    },
    {
      "kind": "deer",
      "x": 14,
      "y": 12
    },
    {
      "kind": "fox",
      "x": 17,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 1,
      "y": 6,
      "w": 7,
      "h": 7
    }
  ],
  "generatorVersion": 3,
  "level": 141,
  "biome": "meadow",
  "par": {
    "reel": 11216,
    "push": 9970,
    "selfPropelled": 9084,
    "tractor": 7575,
    "zeroTurn": 6362,
    "fairway": 4259
  },
  "goldTime": {
    "reel": 11216,
    "push": 9867,
    "selfPropelled": 8958,
    "tractor": 7535,
    "zeroTurn": 6362,
    "fairway": 4082
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 18,
      "selfPropelled": 15,
      "tractor": 10,
      "zeroTurn": 6,
      "fairway": 7
    },
    "gold": {
      "reel": 0,
      "push": 29,
      "selfPropelled": 47,
      "tractor": 44,
      "zeroTurn": 6,
      "fairway": 32
    }
  }
}
